import { render, staticRenderFns } from "./Mall.vue?vue&type=template&id=3f050d1a&scoped=true&"
import script from "./Mall.vue?vue&type=script&lang=js&"
export * from "./Mall.vue?vue&type=script&lang=js&"
import style0 from "./Mall.vue?vue&type=style&index=0&id=3f050d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f050d1a",
  null
  
)

export default component.exports